export { default } from './SliderButlletins';
